Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.ReportView extends Backbone.View

  events:
    'click #build-report': 'addSections'
    'click .start-export': 'startExport'

  initialize: (@options = {}) ->
    @options.chartApi = {
      singleDimension:      '/monitoring/api/charts/single_dimension'
      histogram:            '/monitoring/api/charts/histogram'
      crossDimension:       '/monitoring/api/charts/cross_dimension'
      hierarchy:            '/monitoring/dashboard/charts/hierarchy'
      twitter_followers:    '/monitoring/dashboard/charts/twitter_followers'
      multiple_twitters_followers: '/monitoring/dashboard/charts/multiple_twitters_followers'
      twitter_followers_benchmark: '/monitoring/dashboard/charts/twitter_followers_benchmark'
      twitter_engagement:   '/monitoring/dashboard/charts/twitter_engagement'
      top_five_posts:       '/monitoring/dashboard/charts/top_five_'
      channel_info:         '/monitoring/dashboard/charts/channel_info_'
      channel_reach:        '/monitoring/dashboard/charts/channel_reach_'
      fb_page_impressions:    '/monitoring/dashboard/charts/fb_page_impressions'
      channel_organic_paid_posts:    '/monitoring/dashboard/charts/channel_organic_paid_posts_'
      channel_interactions:    '/monitoring/dashboard/charts/channel_interactions_'
      channel_interactions_engagement:    '/monitoring/dashboard/charts/channel_interactions_engagement_'
      posts_by_label:       '/monitoring/dashboard/charts/posts_by_label_'
      fans_gender:          '/monitoring/dashboard/charts/fans_gender'
      fans_metadata:        '/monitoring/dashboard/charts/fans_metadata'
      facebook_fans:        '/monitoring/dashboard/charts/fans_count'
      sentiment:            '/monitoring/dashboard/charts/interactions_by_sentiment_'
      label_sentiment:      '/monitoring/dashboard/charts/interactions_by_label_and_sentiment_'
      label_ancestors:      '/monitoring/dashboard/charts/label_ancestors_'
      page_growth_over_time: '/monitoring/dashboard/charts/page_growth_over_time'
      fb_page_interactions_with_benchmark: '/monitoring/dashboard/charts/fb_page_interactions_with_benchmark'
      tw_account_interactions_with_benchmark: '/monitoring/dashboard/charts/tw_account_interactions_with_benchmark'
      followers_history:    '/monitoring/dashboard/charts/followers_history'
    }

    @options.colors = {
      positive: '#8ad47b'
      neutral:  '#545454'
      negative: '#ff685f'
      unsentiment: '#cccc52'
      femenino: '#FF99CC'
      masculino: '#66CCFF'
      desconocido: '#B2B2B2' 
    }

    @setUpDates()
    @header = new Monitoring.Reports.Executive.HeaderView(@options)
    @footer = new Monitoring.Reports.Executive.FooterView(@options)
    if @options.settings.sections
      @sections = []
      for object in @options.settings.sections
        section = if typeof object is 'string'
          new Monitoring.Reports.Executive[object](@options)
        else
          s = new Monitoring.Reports.Executive[object.className](@options)
          s.specific_settings = object
          s
        @sections.push(section)
    else
      @sections = [
        # new Monitoring.Reports.Executive.FansFollowersCompetence(@options)
        new Monitoring.Reports.Executive.ShareOfVoiceView(@options)
        new Monitoring.Reports.Executive.UGCCountPerTagView(@options)
        new Monitoring.Reports.Executive.SourceView(@options)
        # new Monitoring.Reports.Executive.BrandsOwnContents(@options)
        # new Monitoring.Reports.Executive.NgramsView(@options)
        new Monitoring.Reports.Executive.CategoriesView(@options)
        new Monitoring.Reports.Executive.HierarchyView(@options)
        # new Monitoring.Reports.Executive.TopTagsComparison(@options)
        new Monitoring.Reports.Executive.BrandSentimentView(@options)
        new Monitoring.Reports.Executive.CompetitorsSentimentView(@options)
        new Monitoring.Reports.Executive.InfluencersView(@options)
        new Monitoring.Reports.Executive.MktAndCommView(@options)
      ]

    $.each @sections, (key, section) =>
      section.bind('sectionReady', @sectionReady)

  setUpDates: ->
    @options.toISO = new Date()
    @options.toISO.setDate(@options.toISO.getDate() - 1)
    @options.toISO.setHours(23, 59, 59, 999)

    @options.fromISO = new Date(@options.toISO)
    @options.fromISO.setDate(1)
    @options.fromISO.setHours(0, 0, 0, 0)

    @options.toBenchmark = new Date(@options.toISO)
    @options.toBenchmark.setMonth(@options.toBenchmark.getMonth() - 1)

    @options.fromBenchmark = new Date(@options.fromISO)
    @options.fromBenchmark.setMonth(@options.fromBenchmark.getMonth() - 1)

  render: ->
    @header.render({from: @from, to: @to})
    @footer.render()
    @$el.html(@header.el)
    @$el.find('.start-export').addClass('disabled')
    return this

  addSections: =>
    @$el.find('.start-export').addClass('disabled')
    @sections_ready = 0
    for section in @sections
      section.render()
      @$el.append(section.el)
    $('.report-index-a.dropdown-toggle').removeClass('hidden')
    $('.report-index.dropdown').removeClass('hidden')

  startExport: (evt) =>
    showNotice('Exporting process started...\nPlease wait')
    data = { sections: [], format: $(evt.currentTarget).data('format') }
    $('.start-export').addClass('disabled')
    @$el.find('.highcharts-button').hide()
    @$el.find('.download-image').hide()
    for section in @sections
      sectionHTML = section.el.outerHTML
      $section = $(sectionHTML)
      $section.find('.container').append(@footer.el)
      sectionHTML = $section.get(0).outerHTML
      data.sections.push sectionHTML
    $.post('/monitoring/reports/exporter/export', data, (response) =>
      @jobId = response.job_id
      @askIfCompleted()
    )

  askIfCompleted: =>
    data = { job_id: @jobId }
    $.get('/monitoring/reports/exporter/export_finish', data, (response) =>
      if response.status == 'completed'
        @downloadPdf()
        $('.start-export').removeClass('disabled')
      else if response.status == 'failed'
        showError('Exportation failed. If this error error persists, please contact us.')
        $('.start-export').removeClass('disabled')
      else if response.status != 'not_found'
        setTimeout(@askIfCompleted, 2000)
    )

  downloadPdf: ->
    location.href = '/monitoring/reports/exporter/download_exported?job_id=' + @jobId

  sectionReady: =>
    @sections_ready += 1
    if @sections_ready >= @sections.length
      $('.start-export').removeClass('disabled')